var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCamera = function SvgCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46 38.75C46 39.8109 45.5786 40.8283 44.8284 41.5784C44.0783 42.3286 43.0609 42.75 42 42.75H6C4.93913 42.75 3.92172 42.3286 3.17157 41.5784C2.42143 40.8283 2 39.8109 2 38.75V16.75C2 15.6891 2.42143 14.6717 3.17157 13.9216C3.92172 13.1714 4.93913 12.75 6 12.75H14L18 6.75H30L34 12.75H42C43.0609 12.75 44.0783 13.1714 44.8284 13.9216C45.5786 14.6717 46 15.6891 46 16.75V38.75Z",
    stroke: "#D9D9D9",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 34.75C28.4183 34.75 32 31.1683 32 26.75C32 22.3317 28.4183 18.75 24 18.75C19.5817 18.75 16 22.3317 16 26.75C16 31.1683 19.5817 34.75 24 34.75Z",
    stroke: "#D9D9D9",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgCamera;